import { PhoneNumberUtil } from 'google-libphonenumber';

const phoneUtil = PhoneNumberUtil.getInstance();

export const normalizePhone = (raw?: unknown, defaultRegion: string = 'US'): string | null => {
  if (typeof raw !== 'string') return null;

  const trimmed = raw.trim();
  if (!trimmed) return null;

  try {
    const number = phoneUtil.parseAndKeepRawInput(trimmed, defaultRegion);

    if (!phoneUtil.isValidNumber(number)) return null;

    return String(number.getNationalNumber());
  } catch {
    return null;
  }
};
